import { useState } from "react";
import { motion } from "framer-motion";
import { TECH_GROUPS } from "@/components/vss/data";

export default function Technology() {
  const [active, setActive] = useState(0);
  const group = TECH_GROUPS[active];

  return (
    <section
      id="technology"
      className="relative py-28 sm:py-36 border-t border-slate-200 bg-slate-50/60"
      data-testid="technology-section"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-14">
          <div className="col-span-12 lg:col-span-6">
            <div className="mb-3 font-mono-a text-[11px] uppercase tracking-[0.28em] text-teal-700">
              / 005 · Technology Expertise
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight leading-[1.05]">
              Four practice areas.
              <br />
              <span className="font-serif-a italic font-normal text-slate-500">
                One coherent engineering surface.
              </span>
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5 lg:col-start-8">
            <p className="text-slate-600 text-base sm:text-lg leading-relaxed">
              Modern stacks, mature engineers. Every category is anchored by
              peer-reviewed technical panels and live coding assessments — never
              resume-only pipelines.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 lg:col-span-4 flex flex-col gap-2">
            {TECH_GROUPS.map((g, i) => (
              <button
                key={g.title}
                onClick={() => setActive(i)}
                data-testid={`tech-tab-${i}`}
                className={`text-left rounded-2xl border transition p-5 sm:p-6 ${
                  active === i
                    ? "border-teal-500/50 bg-white shadow-[0_10px_28px_rgba(20,184,166,0.14)]"
                    : "border-slate-200 hover:border-slate-300 bg-white/70"
                }`}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-mono-a text-[10px] uppercase tracking-[0.28em] text-teal-700 mb-1">
                      0{i + 1}
                    </div>
                    <div className="font-display text-lg sm:text-xl font-bold text-slate-900">
                      {g.title}
                    </div>
                  </div>
                  <div
                    className={`h-2.5 w-2.5 rounded-full ${
                      active === i ? "bg-teal-500" : "bg-slate-300"
                    }`}
                  />
                </div>
              </button>
            ))}
          </div>

          <motion.div
            key={active}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, ease: "easeOut" }}
            className="col-span-12 lg:col-span-8 rounded-3xl border border-slate-200 bg-white p-8 sm:p-12 relative overflow-hidden min-h-[380px]"
            data-testid="tech-detail-panel"
          >
            <div className="absolute -top-32 -right-32 h-80 w-80 rounded-full bg-teal-100/70 blur-3xl pointer-events-none" />
            <div className="font-mono-a text-[10px] uppercase tracking-[0.28em] text-teal-700 mb-4">
              Practice area detail
            </div>
            <h3 className="font-display text-3xl sm:text-4xl text-slate-900 font-bold">
              {group.title}
            </h3>
            <div className="mt-8 flex flex-wrap gap-2.5">
              {group.items.map((it) => (
                <span
                  key={it}
                  className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-4 py-2 text-slate-800 text-sm font-mono-a"
                >
                  <span className="h-1 w-1 rounded-full bg-teal-500" />
                  {it}
                </span>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
